import React from "react";
import "./About_us_content.css";

function About_us_content() {
  return (
    <>
      <section className="About_us_content">
        <div className="container">
            <div className="text_hodler">
                <h2>At Profcyma,</h2>
                <h4>we believe that education has the power to change lives - </h4>
                <p>and that the people who guide learners play an equally transformative role. <br/> With this mission, we built the Profcyma Partner Program, a first-of-its-kind ecosystem that <br/> empowers individuals and businesses to launch and grow their own EdTech venture with zero investment.</p>
            </div>
        </div>
      </section>
    </>
  );
}

export default About_us_content;
